<app-page-title icon="fa-microphone" title="Áudios">
  <a
    [routerLink]="['/call4u-audios/new']"
    class="btn btn-primary btn-icon-right"
  >
    Novo Áudio <i class="fa fa-plus"></i>
  </a>
</app-page-title>

<app-skeleton *ngIf="loading" variant="table-row" [count]="6" [columns]="5"
  label="Carregando os áudios" data-testid="audios-loading"></app-skeleton>

<!-- Tabela de Áudios -->
<div *ngIf="!loading && audios.length > 0" class="card">
  <div class="table-responsive">
    <table class="table table-hover mb-0">
      <thead>
        <tr>
          <th style="width: 25%;">Título</th>
          <th style="width: 20%;">Texto</th>
          <th style="width: 10%;">Status</th>
          <th style="width: 10%; text-align: center;">Reproduzir</th>
          <th style="width: 10%; text-align: center;">Duração</th>
          <th style="width: 15%; text-align: center;">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let audio of audios">
          <!-- Título -->
          <td>
            <strong>{{ audio.title }}</strong>
          </td>

          <!-- Texto -->
          <td>
            <span class="text-truncate d-inline-block" style="max-width: 200px;" [title]="audio.tts_text || ''">
              {{ audio.tts_text || '-' }}
            </span>
          </td>

          <!-- Status -->
          <td>
            <span [class]="getStatusClass(audio.status)">
              {{ getStatusLabel(audio.status) }}
            </span>
          </td>

          <!-- Reproduzir -->
          <td style="text-align: center;">
            <button
              class="btn btn-sm"
              [ngClass]="isPlaying(audio.id) ? 'btn-danger' : 'btn-outline-primary'"
              (click)="togglePlay(audio)"
              [disabled]="!audio.file_url"
              [title]="isPlaying(audio.id) ? 'Parar' : 'Reproduzir'"
            >
              <i class="fa" [ngClass]="isPlaying(audio.id) ? 'fa-stop' : 'fa-play'"></i>
            </button>
          </td>

          <!-- Duração -->
          <td style="text-align: center;">
            {{ formatDuration(audio.duration_seconds) }}
          </td>

          <!-- Ações -->
          <td style="text-align: center;">
            <a
              class="btn btn-sm btn-primary me-1"
              [routerLink]="['/call4u-audios/edit', audio.id]"
              title="Editar"
            >
              <i class="fa fa-edit"></i>
            </a>
            <button
              class="btn btn-sm btn-danger"
              (click)="confirmDelete(audio)"
              title="Excluir"
            >
              <i class="fa fa-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Vazio -->
<div *ngIf="!loading && audios.length === 0" class="card">
  <div class="col">
    Nenhum áudio encontrado.
  </div>
</div>
